// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgwES","col":"styles_col__3zmpO"};